import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/gastos/login',
    name: 'gastos-login',
    component: () => import(/* webpackChunkName: "gastos" */ '@/views/TicketsLoginView.vue')
  },
  {
    // Cargar y Fijos (y antes CSV y foto) ahora están dentro de Mis gastos.
    path: '/gastos/:old(migros|foto|cargar|fijos)',
    redirect: '/gastos/lista'
  },
  {
    // Sin categorizar está arriba de Productos.
    path: '/gastos/pendientes',
    redirect: { path: '/gastos/productos', hash: '#sin-categorizar' }
  },
  {
    // Link de invitación a un espacio compartido: sin sesión pasa por el login y vuelve.
    path: '/gastos/unirse/:token([0-9a-f-]{36})',
    name: 'gastos-unirse',
    component: () => import(/* webpackChunkName: "gastos" */ '@/views/TicketsView.vue'),
    props: (route) => ({ tab: 'dashboard', joinToken: route.params.token }),
    meta: { requiresAuth: true }
  },
  {
    path: '/gastos/:tab(dashboard|lista|productos|saldos)?',
    name: 'gastos',
    component: () => import(/* webpackChunkName: "gastos" */ '@/views/TicketsView.vue'),
    props: (route) => ({ tab: route.params.tab || 'dashboard' }),
    meta: { requiresAuth: true }
  },
  {
    // La sección se llamaba /tickets: los links viejos siguen funcionando.
    path: '/tickets/:rest(.*)*',
    redirect: (to) => ({ path: `/gastos/${[].concat(to.params.rest || []).join('/')}`, query: to.query, hash: to.hash })
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // Solo en /gastos: links como /gastos/productos#sin-categorizar bajan a esa
  // sección. Se espera un poco porque la pestaña se monta y carga datos.
  // La home no se toca (sus anclas #about-me, etc. las maneja el navegador).
  scrollBehavior(to, from, savedPosition) {
    if (!to.path.startsWith('/gastos')) return false
    if (savedPosition) return savedPosition
    // Solo anclas a un id: el hash también puede traer otra cosa (al volver del
    // login con Google trae #access_token=...), que no es un selector válido.
    if (to.hash && !to.hash.includes('=')) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.getElementById(decodeURIComponent(to.hash.slice(1)))
          // Si la sección no está (no hay nada pendiente), arriba de todo.
          resolve(el ? { el, behavior: 'smooth' } : { top: 0 })
        }, 500)
      })
    }
    return to.path === from.path ? false : { top: 0 }
  }
})

// Supabase se importa recién acá, así el sitio público no carga el cliente.
router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth) return true
  const { supabase } = await import(/* webpackChunkName: "gastos" */ '@/lib/supabaseClient')
  if (!supabase) return { name: 'gastos-login' }
  const { data } = await supabase.auth.getSession()
  if (!data.session) return { name: 'gastos-login', query: { redirect: to.fullPath } }
  return true
})

export default router
